import { render, staticRenderFns } from "./BulkPricingEditModal.vue?vue&type=template&id=18d61580"
import script from "./BulkPricingEditModal.vue?vue&type=script&lang=js"
export * from "./BulkPricingEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports